const RichTextEditor = require('./rich-text-editor');

module.exports = {
	options: {
		mode: 'text/html',
		lineNumbers: true
	},
	alternativeEditors: {
		'wysiwyg': {
			label: 'WYSIWYG',
			Editor: RichTextEditor
		},
		'html': 'HTML'
	}
};
